"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactInfoEnum = exports.ContactCourierCardV2 = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _shopeeCommon = require("@mkt-common/shopee-common");
var _Button = require("../Button");
var _Popup = require("../Popup");
var _types = require("../../types");
var _LocaleProvider = require("../LocaleProvider");
var _context = require("../ConfigProvider/context");
var _constants = require("../../utils/constants");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _copy_v = _interopRequireDefault(require("../../assets/images/copy_v2.svg"));
var _phone = _interopRequireDefault(require("../../assets/images/phone.svg"));
var _email_v = _interopRequireDefault(require("../../assets/images/email_v2.svg"));
var _whatsapp = _interopRequireDefault(require("../../assets/images/whatsapp.svg"));
var _facebook = _interopRequireDefault(require("../../assets/images/facebook.svg"));
var _line = _interopRequireDefault(require("../../assets/images/line.svg"));
var _more = _interopRequireDefault(require("../../assets/images/more.svg"));
var _phone_black = _interopRequireDefault(require("../../assets/images/phone_black.svg"));
var _email_black = _interopRequireDefault(require("../../assets/images/email_black.svg"));
var _whatsapp_black = _interopRequireDefault(require("../../assets/images/whatsapp_black.svg"));
var _facebook_black = _interopRequireDefault(require("../../assets/images/facebook_black.svg"));
var _line_black = _interopRequireDefault(require("../../assets/images/line_black.svg"));
var _tools = require("../../utils/tools");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('contact-courier-card-v2');
var ContactInfoEnum;
/**
 * Only for TFE preview
 */

exports.ContactInfoEnum = ContactInfoEnum;
(function (ContactInfoEnum) {
  ContactInfoEnum["Email"] = "email";
  ContactInfoEnum["WhatsApp"] = "whatsapp";
  ContactInfoEnum["Facebook"] = "facebook";
  ContactInfoEnum["Call"] = "call";
  ContactInfoEnum["Line"] = "line";
})(ContactInfoEnum || (exports.ContactInfoEnum = ContactInfoEnum = {}));
var ContactCourierCardV2 = function ContactCourierCardV2(props) {
  var _webformButton$action, _driverInfo$milestone;
  var trackLinks = props.trackLinks,
    _props$contactsInfo = props.contactsInfo,
    contactsInfo = _props$contactsInfo === void 0 ? [] : _props$contactsInfo,
    _props$driverInfo = props.driverInfo,
    driverInfo = _props$driverInfo === void 0 ? {} : _props$driverInfo,
    courierTitle = props.courierTitle,
    orderInfo = props.orderInfo,
    operateTime = props.operateTime,
    handleCopyClick = props.handleCopyClick,
    showDriverInfo = props.showDriverInfo,
    webformButton = props.webformButton,
    onWebformButtonClick = props.onWebformButtonClick,
    isHistory = props.isHistory;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans,
    region = _useLocale.region;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isLinkPopUpActive = _useState2[0],
    setIsLinkPopUpActive = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isContactPopupActive = _useState4[0],
    setIsContactPopupActive = _useState4[1];
  var showWebformButton = (webformButton === null || webformButton === void 0 ? void 0 : webformButton.button_text) && ((_webformButton$action = webformButton.action) === null || _webformButton$action === void 0 ? void 0 : _webformButton$action.formstack);
  var handleTrack = function handleTrack() {
    if ((trackLinks === null || trackLinks === void 0 ? void 0 : trackLinks.length) === 1) {
      var _context$eventEmitter, _context$eventEmitter2, _trackLinks$;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, _types.ButtonEvents.Redirection, {
        text: '',
        action: {
          url_info: {
            url: trackLinks === null || trackLinks === void 0 ? void 0 : (_trackLinks$ = trackLinks[0]) === null || _trackLinks$ === void 0 ? void 0 : _trackLinks$.url
          }
        }
      });
    } else {
      setIsLinkPopUpActive(true);
    }
  };
  var contactButtons = contactsInfo === null || contactsInfo === void 0 ? void 0 : contactsInfo.map(function (item) {
    return _objectSpread({}, item);
  });
  var callButtonIndex = contactButtons.findIndex(function (item) {
    return item.action === ContactInfoEnum.Call;
  });
  var firstButton = callButtonIndex !== -1 ? contactButtons.splice(callButtonIndex, 1)[0] : contactButtons.shift();
  var restButtons = contactButtons;
  var renderContactButton = function renderContactButton(buttonInfo, isFirst) {
    var isCallOrEmail = [ContactInfoEnum.Call, ContactInfoEnum.Email].includes(buttonInfo.action);
    if (isFirst) {
      var _ContactInfoEnum$Call;
      var icon = (_ContactInfoEnum$Call = {}, (0, _defineProperty2.default)(_ContactInfoEnum$Call, ContactInfoEnum.Call, /*#__PURE__*/_react.default.createElement("a", {
        href: "tel:".concat(buttonInfo.information)
      }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _phone.default
      }))), (0, _defineProperty2.default)(_ContactInfoEnum$Call, ContactInfoEnum.Email, /*#__PURE__*/_react.default.createElement("a", {
        href: "mailto:".concat(buttonInfo.information)
      }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _email_v.default
      }))), (0, _defineProperty2.default)(_ContactInfoEnum$Call, ContactInfoEnum.WhatsApp, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _whatsapp.default
      })), (0, _defineProperty2.default)(_ContactInfoEnum$Call, ContactInfoEnum.Facebook, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _facebook.default
      })), (0, _defineProperty2.default)(_ContactInfoEnum$Call, ContactInfoEnum.Line, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _line.default
      })), _ContactInfoEnum$Call)[buttonInfo.action];
      if (!icon) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Button.Button, {
        className: "".concat(PREFIX, "-first-button"),
        action: isCallOrEmail ? undefined : {
          func: _types.ButtonEvents.OpenExternalLink,
          url_info: {
            url: buttonInfo.information
          }
        }
      }, icon);
    } else {
      var _ContactInfoEnum$Call2;
      var buttonContent = (_ContactInfoEnum$Call2 = {}, (0, _defineProperty2.default)(_ContactInfoEnum$Call2, ContactInfoEnum.Call, /*#__PURE__*/_react.default.createElement("a", {
        href: "tel:".concat(buttonInfo.information)
      }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _phone_black.default
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(PREFIX, "-popup-button-text")
      }, trans(_constants.CONTACT_COURIER_CARD.CALL)))), (0, _defineProperty2.default)(_ContactInfoEnum$Call2, ContactInfoEnum.Email, /*#__PURE__*/_react.default.createElement("a", {
        href: "mailto:".concat(buttonInfo.information)
      }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _email_black.default
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(PREFIX, "-popup-button-text")
      }, trans(_constants.CONTACT_COURIER_CARD.EMAIL)))), (0, _defineProperty2.default)(_ContactInfoEnum$Call2, ContactInfoEnum.WhatsApp, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _whatsapp_black.default
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(PREFIX, "-popup-button-text")
      }, trans(_constants.CONTACT_COURIER_CARD.WHATS_APP)))), (0, _defineProperty2.default)(_ContactInfoEnum$Call2, ContactInfoEnum.Facebook, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _facebook_black.default
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(PREFIX, "-popup-button-text")
      }, trans(_constants.CONTACT_COURIER_CARD.FACEBOOK)))), (0, _defineProperty2.default)(_ContactInfoEnum$Call2, ContactInfoEnum.Line, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
        src: _line_black.default
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(PREFIX, "-popup-button-text")
      }, trans(_constants.CONTACT_COURIER_CARD.LINE) || 'Line'))), _ContactInfoEnum$Call2)[buttonInfo.action];
      if (!buttonContent) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Button.Button, {
        className: "".concat(PREFIX, "-popup-button"),
        action: isCallOrEmail ? undefined : {
          func: _types.ButtonEvents.OpenExternalLink,
          url_info: {
            url: buttonInfo.information
          }
        }
      }, buttonContent);
    }
  };
  var renderFirstButton = function renderFirstButton() {
    return firstButton ? renderContactButton(firstButton, true) : null;
  };
  var renderRestButton = function renderRestButton() {
    return restButtons.length > 0 ? /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
      src: _more.default,
      className: "".concat(PREFIX, "-rest-button"),
      onClick: function onClick() {
        return setIsContactPopupActive(true);
      }
    }) : null;
  };
  var renderPopupButtons = function renderPopupButtons() {
    return restButtons.length > 0 ? restButtons.map(function (button) {
      return renderContactButton(button, false);
    }) : null;
  };
  var contactCourier = (0, _tools.replaceParams)(trans(_constants.CONTACT_COURIER_CARD.CONTACT_COURIER) || 'Contact ${courier}', {
    courier: courierTitle
  });
  var contactTitle = "".concat(showDriverInfo && driverInfo !== null && driverInfo !== void 0 && driverInfo.driver_phone ? trans(_constants.CONTACT_COURIER_CARD.CONTACT_DRIVER) || 'Contact Driver' : contactCourier);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-parcel-info")
  }, orderInfo !== null && orderInfo !== void 0 && orderInfo.image ? /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(PREFIX, "-image"),
    src: (0, _shopeeCommon.cdnFile)(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.image, region)
  }) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-main-info")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-title")
  }, courierTitle), orderInfo !== null && orderInfo !== void 0 && orderInfo.shipping_trace_no ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-tracking-number-container")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-tracking-number-text")
  }, orderInfo.shipping_trace_no), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _copy_v.default,
    className: "".concat(PREFIX, "-copy-button"),
    onClick: function onClick() {
      handleCopyClick === null || handleCopyClick === void 0 ? void 0 : handleCopyClick(orderInfo.shipping_trace_no);
    }
  })) : null, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-status")
  }, trans((_driverInfo$milestone = driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.milestone_key) !== null && _driverInfo$milestone !== void 0 ? _driverInfo$milestone : ' ')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-track-and-expedite")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-track-button"),
    onClick: function onClick() {
      handleTrack();
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-track-button-text")
  }, trans(_constants.CONTACT_COURIER_CARD.TRACK_ORDER))), showWebformButton ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-expedite-button"),
    onClick: function onClick() {
      if (!isHistory) {
        onWebformButtonClick === null || onWebformButtonClick === void 0 ? void 0 : onWebformButtonClick(webformButton);
      }
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-expedite-button-text")
  }, webformButton.button_text)) : null), firstButton ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-contact-panel")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-contact-info")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-contact-title")
  }, contactTitle), operateTime !== null && operateTime !== void 0 && operateTime.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-opening-hours-container")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-opening-hours")
  }, operateTime.map(function (v, i) {
    var _v$working_day, _v$working_day2, _v$working_day3, _v$working_hour, _v$working_hour2;
    return "".concat(i !== 0 ? ', ' : '').concat(v === null || v === void 0 ? void 0 : (_v$working_day = v.working_day) === null || _v$working_day === void 0 ? void 0 : _v$working_day.start, " ").concat(v !== null && v !== void 0 && (_v$working_day2 = v.working_day) !== null && _v$working_day2 !== void 0 && _v$working_day2.end ? '- ' + (v === null || v === void 0 ? void 0 : (_v$working_day3 = v.working_day) === null || _v$working_day3 === void 0 ? void 0 : _v$working_day3.end) : '', " (").concat(v === null || v === void 0 ? void 0 : (_v$working_hour = v.working_hour) === null || _v$working_hour === void 0 ? void 0 : _v$working_hour.start, " - ").concat(v === null || v === void 0 ? void 0 : (_v$working_hour2 = v.working_hour) === null || _v$working_hour2 === void 0 ? void 0 : _v$working_hour2.end, ")");
  }))) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-contact-buttons")
  }, renderFirstButton(), renderRestButton())) : null, /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    active: isLinkPopUpActive,
    onClose: function onClose() {
      return setIsLinkPopUpActive(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-link-popup")
  }, trackLinks.map(function (v, i) {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: "".concat(PREFIX, "-link-button"),
      action: {
        func: _types.ButtonEvents.Redirection,
        url_info: {
          url: v.url
        }
      },
      text: v.url,
      type: "link",
      key: i
    });
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-link-popup-gap")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-link-cancel-button"),
    onClick: function onClick() {
      return setIsLinkPopUpActive(false);
    }
  }, trans(_constants.CONTACT_COURIER_CARD.CANCEL) || 'Cancel'))), /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: contactCourier,
    active: isContactPopupActive,
    onClose: function onClose() {
      return setIsContactPopupActive(false);
    },
    showCloseIcon: true,
    titleClassName: "".concat(PREFIX, "-contact-popup-title")
  }, /*#__PURE__*/_react.default.createElement("div", null, operateTime !== null && operateTime !== void 0 && operateTime.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-popup-opening-hours-container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-popup-opening-hours-content")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-popup-opening-hours")
  }, trans(_constants.CONTACT_COURIER_CARD.OPERATION_HOURS), ":", ' ', operateTime.map(function (v, i) {
    var _v$working_day4, _v$working_day5, _v$working_day6, _v$working_hour3, _v$working_hour4;
    return "".concat(i !== 0 ? ', ' : '').concat(v === null || v === void 0 ? void 0 : (_v$working_day4 = v.working_day) === null || _v$working_day4 === void 0 ? void 0 : _v$working_day4.start, " ").concat(v !== null && v !== void 0 && (_v$working_day5 = v.working_day) !== null && _v$working_day5 !== void 0 && _v$working_day5.end ? '- ' + (v === null || v === void 0 ? void 0 : (_v$working_day6 = v.working_day) === null || _v$working_day6 === void 0 ? void 0 : _v$working_day6.end) : '', " (").concat(v === null || v === void 0 ? void 0 : (_v$working_hour3 = v.working_hour) === null || _v$working_hour3 === void 0 ? void 0 : _v$working_hour3.start, " - ").concat(v === null || v === void 0 ? void 0 : (_v$working_hour4 = v.working_hour) === null || _v$working_hour4 === void 0 ? void 0 : _v$working_hour4.end, ")");
  })))) : null, renderPopupButtons())));
};
exports.ContactCourierCardV2 = ContactCourierCardV2;